module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('custom-table', {
    attrs: {
      "edit": "/users/{:id}",
      "add": "/users/new",
      "default-sort": _vm.defSort,
      "search": "",
      "src-model": _vm.$store.getters.models('users'),
      "cols": _vm.cols
    },
    on: {
      "print": _vm.print
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Benutzerverwaltung")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f8e7833!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UserOverview.vue
// module id = 439
// module chunks = 0